import { memo, VFC, useState } from 'react';
import {
  Center,Heading,Box,Flex,
} from '@chakra-ui/react';
import { NoticeTable } from '../molecules/NoticeTable';

export const NoticeView: VFC = memo(() => {
  const [ title ] = useState('通知メール履歴');

  return (
    <Center> 
      <Box
        w="100%"
        bg="white"
        shadow="md"
        marginTop="10px"
        marginRight="10px"
        borderRadius="10px"
      >
        <Flex>
          <Heading size="md" margin="10px">
            <Flex>{`■${title}`}</Flex>
          </Heading> 
        </Flex>
        <Box margin="10px">
          <NoticeTable />
        </Box>
      </Box>  
    </Center>
  );
});